import React from 'react';
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Layout,
} from 'antd';

import * as ROUTES from 'config/constants/routes';
import { withFirebase } from 'services/firebase';

const { Header, Content } = Layout;

class Login extends React.Component {
  state = {
    error: '',
    confirmDirty: false,
  }

  componentWillMount() {
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      const { email, password, first_name, last_name, company } = values;
      if (err) return;

      try {
        await this.props.firebase.auth.createUserWithEmailAndPassword(email, password);
        const newCompany = this.props.firebase.companies().push({ name: company }); // after
        const user = await this.props.firebase.user;
        user.set({
          first_name,
          last_name,
          email,
          company, // final step
          companyId: newCompany.key,
        });

        this.setState({ error: '' });
        this.props.history.push(ROUTES.CONFIGURATION);
      }
      catch (error) {
        this.setState({ error: error.message });
      }
    });
  }

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Passwords do not match');
    }
    else {
      callback();
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  }

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Layout
        style={{
          height:"100vh",
          'backgroundImage': 'linear-gradient(to right bottom, rgb(255, 255, 255), rgb(247, 249, 255), rgb(234, 245, 255), rgb(217, 241, 255), rgb(198, 239, 255))',
          'backgroundSize': 'cover'
        }}
      >
        <Header style={{background:"rgba(255, 255, 255, 0)"}}>
          <a href='https://www.convodo.io'>
            <img
              src={require('assets/images/logo-with-text.svg')}
              style={{height:"3em"}}
              alt="logo"
            />
          </a>
        </Header>
        <Content
          style={{
            height:"100%",
            background:"rgba(255, 255, 255, 0)"
          }}
        >
            <Row type="flex" justify="center" align="middle" style={{height:"100%"}}>
              <Col xs={22} sm={16} md={12} lg={8} xl={6} >
                <Form onSubmit={this.handleSubmit} className="login-form">
                  <Card
                    className="login-card"
                    style={{'boxShadow':'0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -2px rgba(0,0,0,.05)'}}
                  >
                    <h1>Create your account</h1>
                    <Row gutter={12}>
                      <Col span={12}>
                        <Form.Item>
                          {getFieldDecorator('first_name', {
                            rules: [
                              { required: true, message: 'Please input your first name!' },
                            ],
                          })(
                            <Input placeholder="First Name" />
                          )}
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item>
                          {getFieldDecorator('last_name', {
                            rules: [
                              { required: true, message: 'Please input your last name!' },
                            ],
                          })(
                            <Input placeholder="Last Name" />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>

                    <Form.Item>
                      {getFieldDecorator('email', {
                        rules: [
                          { type: 'email', message: "hmm... that doesn't seem to be a valid e-mail" },
                          { required: true, message: 'Please include your e-mail' },
                        ],
                      })(
                        <Input placeholder="E-mail" />
                      )}
                    </Form.Item>

                    <Form.Item>
                      {getFieldDecorator('company', {
                        rules: [
                          { required: true, message: 'Please include company name' },
                        ],
                      })(
                        <Input placeholder="Company Name" />
                      )}
                    </Form.Item>

                    <Form.Item>
                      {getFieldDecorator('password', {
                        rules: [
                          { required: true, message: 'Please include your password' },
                          { validator: this.validateToNextPassword },
                        ],
                      })(
                        <Input type="password" placeholder="Password" />
                      )}
                    </Form.Item>

                    <Form.Item>
                      {getFieldDecorator('confirm', {
                        rules: [
                          { required: true, message: 'Please confirm your password' },
                          { validator: this.compareToFirstPassword },
                        ],
                      })(
                        <Input type="password" placeholder="Confirm Password" onBlur={this.handleConfirmBlur} />
                      )}
                    </Form.Item>

                    <Form.Item>
                      <p className="form-error">{this.state.error}</p>
                      <Button type="primary"  htmlType="submit" size="large" className="login-form-button" shape="round">
                        Register
                      </Button>

                      Or <a href={ROUTES.LOGIN}>sign into your existing account.</a>
                    </Form.Item>

                  </Card>
                </Form>
            </Col>
          </Row>

        </Content>
      </Layout>
    );
  }
}

export default withFirebase(Form.create({ name: 'login_form' })(Login));
